import { render, staticRenderFns } from "./partenr-income-order.vue?vue&type=template&id=82c12d80&scoped=true&"
import script from "./partenr-income-order.vue?vue&type=script&lang=js&"
export * from "./partenr-income-order.vue?vue&type=script&lang=js&"
import style0 from "./partenr-income-order.vue?vue&type=style&index=0&id=82c12d80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c12d80",
  null
  
)

export default component.exports